






















































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { apiMaterialCategoryAdd, apiMaterialCategoryEdit, apiMaterialCategoryDetail, apiMaterialCategoryList } from '@/api/material'
import MaterialSelect from '@/components/material-select/index.vue'
import { MaterialCategoryType, UnitType } from '@/utils/type'

@Component({
  components: {
    MaterialSelect
  }
})
export default class MaterialCategoryEdit extends Vue {
    categoryForm: any = {
      category_code: '',
      category_name: '',
      pid: 0,
      level: 1,
      category_type: MaterialCategoryType.other,
      unit_type: UnitType.piece,
      stock_warning_enabled: 1,
      min_stock: 5,
      max_stock: 100,
      shelf_life_days: 0,
      storage_conditions: '',
      image: '',
      sort: 255,
      is_enabled: 1
    }

    rules = {
      category_code: [
        { required: true, message: '请输入分类编码', trigger: 'blur' },
        { max: 50, message: '分类编码不能超过50个字符', trigger: 'blur' }
      ],
      category_name: [
        { required: true, message: '请输入分类名称', trigger: 'blur' },
        { max: 100, message: '分类名称不能超过100个字符', trigger: 'blur' }
      ],
      category_type: [
        { required: true, message: '请选择收费类型', trigger: 'change' }
      ],
      unit_type: [
        { required: true, message: '请选择计量单位', trigger: 'change' }
      ],
      min_stock: [
        { type: 'number', min: 0, message: '最低库存不能小于0', trigger: 'blur' }
      ],
      max_stock: [
        { type: 'number', min: 0, message: '最高库存不能小于0', trigger: 'blur' }
      ],
      sort: [
        { type: 'number', min: 0, message: '排序不能小于0', trigger: 'blur' }
      ]
    }

    loading = false
    parentCategoryList: any[] = []
    categoryTypeList = [
      { value: MaterialCategoryType.cleaning, label: '保洁用品' },
      { value: MaterialCategoryType.repair, label: '维修材料' },
      { value: MaterialCategoryType.linen, label: '布草类' },
      { value: MaterialCategoryType.consumable, label: '易耗品' },
      { value: MaterialCategoryType.equipment, label: '设备配件' },
      { value: MaterialCategoryType.office, label: '办公用品' },
      { value: MaterialCategoryType.food, label: '食品饮料' },
      { value: MaterialCategoryType.other, label: '其他' }
    ]

    unitTypeList = [
      { value: UnitType.piece, label: '个' },
      { value: UnitType.item, label: '件' },
      { value: UnitType.set, label: '套' },
      { value: UnitType.bottle, label: '瓶' },
      { value: UnitType.pack, label: '包' },
      { value: UnitType.roll, label: '卷' },
      { value: UnitType.meter, label: '米' },
      { value: UnitType.kilogram, label: '千克' },
      { value: UnitType.liter, label: '升' }
    ]

    get isEdit () {
      return this.$route.query.id
    }

    get alertTitle () {
      return this.isEdit
        ? '温馨提示：编辑分类信息，修改后会影响相关物料的分类设置。'
        : '温馨提示：新增分类需要完善基本信息、库存设置等内容。'
    }

    handleStockWarningChange (value: number) {
      if (value === 0) {
        this.categoryForm.min_stock = 0
        this.categoryForm.max_stock = 0
      }
    }

    formatCategoryLabel (category: any): string {
      let label = category.category_name
      if (category.level > 1) {
        const indent = '　'.repeat(category.level - 1)
        label = `${indent}└ ${label}`
      }
      return label
    }

    async getCategoryList () {
      try {
        apiMaterialCategoryList().then((res: any) => {
          this.parentCategoryList = res.lists || []
          // 如果是编辑模式，从列表中去掉当前分类及其子分类
          if (this.isEdit) {
				    const removeIds = this.getCategoryAndChildrenIds(this.isEdit as string, res.lists || [])
				    this.parentCategoryList = this.parentCategoryList.filter(item => !removeIds.includes(item.id))
          }
        })
      } catch (error) {
        console.error('获取分类列表失败:', error)
      }
    }

    getCategoryAndChildrenIds (categoryId: string, categories: any[]): number[] {
      const ids: number[] = [parseInt(categoryId)]
      const findChildren = (parentId: number) => {
        categories.forEach(item => {
          if (item.pid === parentId) {
            ids.push(item.id)
            findChildren(item.id)
          }
        })
      }
      findChildren(parseInt(categoryId))
      return ids
    }

    async getCategoryDetail () {
      if (this.isEdit) {
        try {
          const res = await apiMaterialCategoryDetail({ id: this.$route.query.id })
          const data = res?.data || {}

          // 填充表单数据
          Object.keys(this.categoryForm).forEach(key => {
            if (data[key] !== undefined) {
              this.categoryForm[key] = data[key]
            }
          })

          // 确保pid是数字
          this.categoryForm.pid = Number(this.categoryForm.pid) || 0
        } catch (error) {
          console.error('获取分类详情失败:', error)
          this.$router.go(-1)
        }
      }
    }

    async handleSubmit () {
      try {
        await (this.$refs.categoryForm as any).validate()

        this.loading = true
        const params = { ...this.categoryForm }

        // 根据pid计算level
        if (params.pid === 0) {
          params.level = 1
        } else {
          const parentCategory = this.parentCategoryList.find(item => item.id === params.pid)
          params.level = (parentCategory?.level || 1) + 1
        }

        if (this.isEdit) {
          params.id = this.$route.query.id
          await apiMaterialCategoryEdit(params)
        } else {
          await apiMaterialCategoryAdd(params)
        }

        this.$router.push('/material/category')
      } catch (error: any) {
        if (error && error.message !== 'cancel') {
          console.error('保存失败:', error)
        }
      } finally {
        this.loading = false
      }
    }

    async created () {
      await this.getCategoryList()
      await this.getCategoryDetail()

      if (!this.isEdit) {
        // 如果是新增且传入了pid参数，则设置父级分类
        const pid = this.$route.query.pid
        if (pid) {
          this.categoryForm.pid = Number(pid)

          // 如果有level参数，设置level（用于计算新增子分类的层级）
          const level = this.$route.query.level
          if (level) {
            this.categoryForm.level = Number(level)
          }
        }

        // 生成分类编码
        if (!this.categoryForm.category_code) {
          const timestamp = new Date().getTime().toString()
            .slice(-6)
          this.categoryForm.category_code = `CAT${timestamp}`
        }
      }
    }
}
